import React from 'react';
import { Typography } from '@mui/material';
import PageLayout from '../components/common/PageLayout';

const AddCustomerPage = () => (
  <PageLayout
    title="Add Customer"
    backFallbackPath="/customerhub/customers/"
    contentPadding={{ xs: 2, sm: 3 }}
  >
    <Typography variant="body1" color="text.secondary">
      Add customer form can be implemented here.
    </Typography>
  </PageLayout>
);

export default AddCustomerPage;
